@if (loading) {
  <div id="pageloader" class="animate">
    <div class="dot1"></div>
    <div class="dot2"></div>
  </div>
}
